import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';


@Injectable()
export class Interceptor implements HttpInterceptor {

    constructor(private authService: AuthService) {

    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = this.getRequest(request);
        return next.handle(request);
    }

    private getRequest(request: HttpRequest<any>) {

        // request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        //  request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
        // request = request.clone({ headers: request.headers.set('X-Kite-Version', '3') });

        // uncomment for without Login
        // request = request.clone({
        //     headers: request.headers.set('Authorization',
        //         // v`${this.authService.authorizationHeaderValue}`)
        //         `Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjV0aFJiM19Jcld1Y1dHR2drcFlKTHciLCJ0eXAiOiJhdCtqd3QifQ.eyJuYmYiOjE2Mjg1MjMxMzAsImV4cCI6MTY2MDA1OTEzMCwiaXNzIjoiaHR0cDovL3BpeGVsdHJhZGUubG9jYWwvaWRlbnRpdHkiLCJhdWQiOiJwaXhlbHRyYWRlYXBpIiwiY2xpZW50X2lkIjoicGl4ZWx0cmFkZXVpIiwic3ViIjoiYjU2MGYyNzMtMDRkZi00Nzg5LTkxOTctNGQwZTlhMjZiZGM2IiwiYXV0aF90aW1lIjoxNjI4NTIzMTMwLCJpZHAiOiJsb2NhbCIsImdpdmVuX25hbWUiOiJoYW51LnVuYWgyQGdtYWlsLmNvbSIsImVtYWlsIjoiaGFudS51bmFoMkBnbWFpbC5jb20iLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiJBRE1JTiIsInNjb3BlIjpbIm9wZW5pZCIsInByb2ZpbGUiLCJlbWFpbCIsInBpeGVsdHJhZGVhcGkucmVhZCJdLCJhbXIiOlsicHdkIl19.UKf2ZgtvjnVuy5LaOoxPzhoDTWYizfxfxm1woIzpepVQuayT_73SKX6jk-RBxLxIyfHt2OnMB18PvdAEIe6pkjBIWhkuFonnT5o9uovJyXPP3XqVymuPDaKsR7BkV79VQBi5VOhrJZ3bPwakr80NlxyiOmmhuyjrbrZncwh42FYQ_0KQo5FRUuK9fBCbomFrDLX65xzvOwML9UG-z-mIboVmJ3hsYh4cXkIzNEMjJsfRNum4hCc53VoVwJYNVPhCCycqntClVlS5-X28k_dmW3q25m4-9jlRGii4SQo3RckZsM42c9p_kUHlNDfeLVuqQoc6ynxytN3egvTZjILwBQ`)

        //     // server
        //     // `Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjV0aFJiM19Jcld1Y1dHR2drcFlKTHciLCJ0eXAiOiJhdCtqd3QifQ.eyJuYmYiOjE2MjgzMzkzNTcsImV4cCI6MTY1OTg3NTM1NywiaXNzIjoiaHR0cHM6Ly9zcG90dHJhZGUuaW4vaWRlbnRpdHkiLCJhdWQiOiJwaXhlbHRyYWRlYXBpIiwiY2xpZW50X2lkIjoicGl4ZWx0cmFkZXVpIiwic3ViIjoiYjU2MGYyNzMtMDRkZi00Nzg5LTkxOTctNGQwZTlhMjZiZGM2IiwiYXV0aF90aW1lIjoxNjI4MzM5MzU2LCJpZHAiOiJsb2NhbCIsImdpdmVuX25hbWUiOiJoYW51LnVuYWgyQGdtYWlsLmNvbSIsImVtYWlsIjoiaGFudS51bmFoMkBnbWFpbC5jb20iLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiJBRE1JTiIsInNjb3BlIjpbIm9wZW5pZCIsInByb2ZpbGUiLCJlbWFpbCIsInBpeGVsdHJhZGVhcGkucmVhZCJdLCJhbXIiOlsicHdkIl19.PEoU4GBtBkwCsGcWPUdUj88KCP0_ayjlSVXjrpGjyKgANVKZtEFyMhAOEa89OyUZ-EOxL6wgktTikIbVwFnfIgudifZkbNDvJuoVPfpEvgOmvfJmSX5leXsNwdg4vpWU9ykK-nf7MWZuVaVorEWuTjhdCnr7XyH4m3axlQFrKhYnQXSCqKyTpmhuiuCzNt_n1lGD5mOtV3n0mrboe4dMIpK2VOYKLJsIeZ7JikfKlPntsOCULi90ebEswtgZ2CJK5dH3b09aoTN2HPUF7zt8H1l5GHMIdZhb3Idth-85mLQpSwMrPQFMkP_q_-f1L_s29wHAM-j9SSLx_4PuMXx_Hw`)

        // })

        request = request.clone({
            headers: request.headers.set('Authorization',
                `${this.authService.authorizationHeaderValue}`)
        })

        // request = request.clone({ headers: request.headers.set('Access-Control-Allow-Origin', '*') });

        return request;
    }
}
